import * as React from "react";
import { useCallback } from "react";
import styled, { css } from "styled-components";
import { Menu as MantineMenu } from "@mantine/core";
import Link from "components/common/Link";
import Icon from "components/common/Icon";
import Menu from "../Menu";
const StyledMenuItem = styled(MantineMenu.Item)(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    font-size: ${theme.fonts.size.body};
    white-space: nowrap;

    &:hover,
    &:focus {
      text-decoration: none;
      color: inherit;
      background-color: ${theme.utils.colorLevel(theme.colors.global.contentBackground, 10)};
    }
  `
);
const StyledMenuDivider = styled(MantineMenu.Divider)(
  ({ theme }) => css`
    border-color: ${theme.colors.variant.lighter.default};
  `
);
const CustomMenuItem = ({
  children = void 0,
  className = void 0,
  disabled = false,
  divider = false,
  eventKey = void 0,
  header = false,
  href = void 0,
  icon = void 0,
  id = void 0,
  onClick = void 0,
  onSelect = void 0,
  rel = void 0,
  target = void 0,
  title = void 0,
  "data-tab-id": dataTabId = void 0,
  component = void 0,
  closeMenuOnClick = void 0
}) => {
  const callback = onClick != null ? onClick : onSelect;
  const _onClick = useCallback(() => callback == null ? void 0 : callback(eventKey), [callback, eventKey]);
  if (divider) {
    return /* @__PURE__ */ React.createElement(StyledMenuDivider, { role: "separator", className, id });
  }
  if (header) {
    return /* @__PURE__ */ React.createElement(Menu.Label, { role: "heading", className, id }, children);
  }
  const sharedProps = {
    className,
    "data-tab-id": dataTabId,
    disabled,
    leftSection: icon ? /* @__PURE__ */ React.createElement(Icon, { name: icon }) : null,
    id,
    onClick: _onClick,
    title,
    closeMenuOnClick
  };
  if (href && component === "a") {
    return /* @__PURE__ */ React.createElement(
      StyledMenuItem,
      {
        component: "a",
        href,
        rel: rel != null ? rel : target === "_blank" ? "noopener noreferrer" : void 0,
        target,
        ...sharedProps
      },
      children
    );
  }
  if (href) {
    return /* @__PURE__ */ React.createElement(StyledMenuItem, { component: Link, to: href, rel, target, ...sharedProps }, children);
  }
  return /* @__PURE__ */ React.createElement(StyledMenuItem, { component, ...sharedProps }, children);
};
export default CustomMenuItem;
